import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/sfz1.png'
import _imports_1 from '@/assets/images/sfz2.png'


const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "upload-area" }
const _hoisted_3 = { class: "upload-item" }
const _hoisted_4 = { class: "upload-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "default-box"
}
const _hoisted_7 = { class: "upload-item" }
const _hoisted_8 = { class: "upload-box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "default-box"
}
const _hoisted_11 = { class: "submit-btn" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { ref } from "vue";
import { showToast } from 'vant';
import { useRouter } from 'vue-router';
import type { UploaderFileListItem, UploaderBeforeRead, UploaderAfterRead } from 'vant';
import { uploadFile } from '@/api/system';
import { uploadSfz } from '@/api/wallet';


export default /*@__PURE__*/_defineComponent({
  __name: 'authSfz',
  setup(__props) {

const router = useRouter();
const frontImage = ref('');
const backImage = ref('');
const frontFileList = ref<UploaderFileListItem[]>([]);
const backFileList = ref<UploaderFileListItem[]>([]);

// 添加图片压缩函数
const compressImage = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置压缩后的尺寸（建议最大宽度为1024）
        const maxWidth = 1024;
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = (maxWidth * height) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx?.drawImage(img, 0, 0, width, height);

        // 转换为 blob，压缩质量为 0.8
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }));
          } else {
            reject(new Error('压缩失败'));
          }
        }, 'image/jpeg', 0.8);
      };
    };
    reader.onerror = reject;
  });
};

// 修改上传前校验
const beforeRead: UploaderBeforeRead = (file) => {
  const currentFile = Array.isArray(file) ? file[0] : file;
  const isImage = currentFile.type.includes('image');
  if (!isImage) {
    showToast('请上传图片格式文件');
    return false;
  }

  // 检查文件大小（例如：限制为 10MB）
  const maxSize = 10 * 1024 * 1024;
  if (currentFile.size > maxSize) {
    showToast('图片大小不能超过10MB');
    return false;
  }

  return true;
};

// 修改上传后处理
const afterRead: UploaderAfterRead = async (file, detail) => {
  const currentFile = Array.isArray(file) ? file[0] : file;
  try {
    // 压缩图片
    const compressedFile = await compressImage(currentFile.file as File);

    // 生成新的文件名
    const timestamp = new Date().getTime();
    const fileExt = compressedFile.name.split('.').pop();
    const newFileName = `sfz_${detail.name}.${fileExt}`;

    // 创建新的 File 对象，使用新文件名
    const renamedFile = new File([compressedFile], newFileName, {
      type: compressedFile.type
    });

    const formData = new FormData();
    formData.append('file', renamedFile);

    const res = await uploadFile(formData);
    if (detail.name === 'front') {
      frontImage.value = res.data;
    } else {
      backImage.value = res.data;
    }
  } catch (error) {
    showToast('上传失败，请重试');
  }
};

// 删除图片
const onDelete = (type: 'front' | 'back') => {
  if (type === 'front') {
    frontImage.value = '';
  } else {
    backImage.value = '';
  }
};

// 提交表单
const handleSubmit = async () => {
  if (!frontImage.value || !backImage.value) {
    showToast('请上传身份证正反面照片');
    return;
  }
  // 处理提交逻辑
  console.log(frontImage.value, backImage.value);
  try {
    const res = await uploadSfz({
      frontPicCode: frontImage.value,
      backPicCode: backImage.value
    });
    console.log(res);
    if (res.code === 200) {
      showToast('上传成功');
      router.go(-1);
    } else {
      showToast(res.msg);
    }
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "上传身份证" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "upload-title" }, "拍摄人像面", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_uploader, {
              modelValue: frontFileList.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((frontFileList).value = $event)),
              "max-count": 1,
              "before-read": beforeRead,
              onDelete: _cache[1] || (_cache[1] = ($event: any) => (onDelete('front'))),
              "after-read": afterRead,
              name: "front",
              "preview-size": 170,
              "preview-image": true
            }, {
              default: _withCtx(() => [
                (frontImage.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: frontImage.value,
                      class: "preview-image"
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "sfz-icon"
                      }, null, -1)
                    ])))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "upload-title" }, "拍摄国徽面", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_uploader, {
              modelValue: backFileList.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((backFileList).value = $event)),
              "max-count": 1,
              "before-read": beforeRead,
              onDelete: _cache[3] || (_cache[3] = ($event: any) => (onDelete('back'))),
              "after-read": afterRead,
              name: "back",
              "preview-size": 170,
              "preview-image": true
            }, {
              default: _withCtx(() => [
                (backImage.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: backImage.value,
                      class: "preview-image"
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[6] || (_cache[6] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "sfz-icon"
                      }, null, -1)
                    ])))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          round: "",
          onClick: handleSubmit,
          disabled: !frontImage.value || !backImage.value
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" 上传 ")
          ])),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 64))
}
}

})